module.exports = __webpack_public_path__ + "img/pencil-icon.64f0b18c.svg";